<div class="pr-4" style="width:95vw; padding-left: 2vw;">
  <mat-card class="pl-4" style="height: 98vh;overflow-y: auto">

    <div class="row" style="align-items: center">
      <div class="pr-2">
        <app-squares-vertical-line></app-squares-vertical-line>
      </div>
      <div class="pt-2 col-7 col-xl-8">
        <h2>OZNAMY</h2>
      </div>
    </div>

    <div class="pl-3" style="font-size: 1.1em">
      <ng-container *ngFor="let announcement of announcements; let last = last">
        <div class="col-12 px-0 pb-2 pt-2" [innerHTML]="announcement.text"></div>
        <mat-divider *ngIf="!last"></mat-divider>
      </ng-container>
    </div>

  </mat-card>
</div>
